export class AwsNativeHighFrequencyBackupSchedules {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "targetRegion",
            "baseName": "targetRegion",
            "type": "string",
            "format": ""
        },
        {
            "name": "scheduleConfig",
            "baseName": "scheduleConfig",
            "type": "HighFrequencyBackupScheduleConfig",
            "format": ""
        },
        {
            "name": "backupRetentionDays",
            "baseName": "backupRetentionDays",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsNativeHighFrequencyBackupSchedules.attributeTypeMap;
    }
    constructor() {
    }
}
